import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  CustomTextField,
  CustomTitle,
  CustomText,
  CustomButton,
  CustomCheckbox,
} from "../../components/Custom";
import MenuItem from "@mui/material/MenuItem";
import "./index.css";
import Service from "../../services";
import { useFormik } from "formik";
import validationSchema from "./validation";
import { Checkbox, ListItemText, Select, InputLabel, FormControl } from '@mui/material';
import Validation from '../../components/Validation'

const CreateRequest = (props) => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [columnsRequired, setColumnsRequired] = useState([]);
  const [selectedValidations, setSelectedValidations] = useState([]);
  const [validationOptions, setValidationOptions] = useState([]);


  const handleValidationChange = (event) => {
    setSelectedValidations(event.target.value);
  };

  const removeValidation = (id) => {
    console.log("i got here")
    setSelectedValidations((prev) => prev.filter((item) => item !== id));
  };

  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: {
      requestName: "",
      database_type: "",
      dbOperationType: "",
      noOfColumnsRequired: "",
      database_table: "",
      database_name: "",
      executionMethod: "",
      zonalApproval: true,
      overrideApproval: "",
      shpHeadApproval: "",
      requestTypeDescription: "",
      validations: []
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // alert(JSON.stringify(values, null, 4));
      console.log(columnsRequired);

      saveFormData(values);
    },
  });
  //HANDLE FORM SUBMIT

  async function saveFormData(values) {
    let payload = {
      staff_id: JSON.parse(sessionStorage.getItem("userDetails")).staff_id,
      requestName: values.requestName,
      db_type: values.database_type,
      dbOperationType: values.dbOperationType,
      noOfColumnsRequired: values.noOfColumnsRequired,
      columnsRequired: columnsRequired,
      database_table: values.database_table,
      database_name: values.database_name,
      zonalApproval: values.zonalApproval,
      shpHeadApproval: values.shpHeadApproval,
      overrideApproval: values.overrideApproval,
      executionMethod: values.executionMethod,
      description: values.requestTypeDescription,
      validations: selectedValidations
    };
    setErrorMsg(false);
    setLoading(true);
    console.log("handlesubmit");
    const response = await Service.createRequest(payload);
    console.log(response);
    // const responseMessage = response.message;
    if (response.status === 200 || response.status === 201) {
      setLoading(false);
      setSubmitted(true);
      window.setTimeout(function () {
        navigate(0);
      }, 2000);
    }
    else {
      setLoading(false);
      setErrorMsg(true);
      window.setTimeout(function () {
        setErrorMsg(false);
      }, 6000);
    }
    // console.log(responseData);
  }

  const onChangeColumnName = (index) => (e) => {
    const newValue = e.target.value;
    const newLDCKey = e.target.id;
    let newArr = [...columnsRequired];
    newArr[index].name = newValue;
    // console.log(newArr);
    setColumnsRequired(newArr);
  };
  const onChangeDefault = (index) => (e) => {
    const newValue = e.target.value;
    const newLDCKey = e.target.id;
    let newArr = [...columnsRequired];
    newArr[index].default = newValue;
    // console.log(newArr);
    setColumnsRequired(newArr);
  };
  const onChangeColumnParams = (index, e) => {
    console.log(e.target.checked);
    console.log(e.target.name);
    console.log(index);

    let newArr = [...columnsRequired];
    newArr[index][e.target.name] = e.target.checked;
    // // console.log(newArr);
    setColumnsRequired(newArr);
  };
  // const onChangeExecutionMethod = (e) => {
  //   console.log(e.target.value);
  //   if (e.target.value === "override") {
  //     formik.values.shpHeadApproval = formik.values.zonalApproval === false;
  //   }

  //   formik.values.executionMethod = e.target.value;
  // };
  useEffect(() => {
    if (formik.values.executionMethod === "override") {
      formik.values.zonalApproval = formik.values.shpHeadApproval = false;
    } else {
      formik.values.zonalApproval = true;
    }
  }, [formik.values.executionMethod]);

  //set Columns Required Object
  function setColumnsInfo() {
    let rows = [];
    if (
      formik.values.noOfColumnsRequired % 1 === 0 &&
      formik.values.noOfColumnsRequired < 51
    ) {
      for (var i = 0; i < formik.values.noOfColumnsRequired; i++) {
        rows = [...Array(formik.values.noOfColumnsRequired).keys()].map(
          (rows) => rows + 1
        );
      }
    }
    let columnRows = rows.slice(0, 50);
    console.log(columnRows);
    console.log(rows);
    let columnObject = [];
    if (columnRows.length > 0) {
      columnRows.forEach(function (item) {
        console.log(item);
        columnObject.push({
          name: "",
          isKey: false,
          isNumber: false,
          isVerified: false,
          isUpdate: false,
          default: "",
        });
        // columnsRequired.push({ name: "", isKey: "" });
      });
      setColumnsRequired(columnObject);
    }
  }
  useEffect(() => {
    setColumnsInfo();
  }, [formik.values.noOfColumnsRequired]);

  console.log(columnsRequired);
  function getColumnsRequired() {
    var displayColumnsRequired = columnsRequired.map((item, index) => (
      <>
        <Grid container sx={{ py: 2, px: 2 }} key={item.key} spacing={5}>
          <Grid item xs={2.5}>
            <CustomText> Column {index + 1}</CustomText>
            <CustomTextField
              type="text"
              name={`column${index}Name`}
              id={`column${index}Name`}
              value={item.name || ""}
              onChange={onChangeColumnName(index)}
              placeholder="Enter column name"
              sx={{ mb: 2 }}
              fullWidth
            />
          </Grid>
          <Grid item xs={2} sx={{ mt: 2 }}>
            {" "}
            <FormControlLabel
              name="isKey"
              onChange={(e) => {
                onChangeColumnParams(index, e);
              }}
              control={
                <CustomCheckbox checked={item.isKey || false} sx={{ pt: 2 }} />
              }
              label="Is Key"
              labelPlacement="top"
            />
          </Grid>
          <Grid item xs={2} sx={{ mt: 2 }}>
            <FormControlLabel
              name="isNumber"
              onChange={(e) => {
                onChangeColumnParams(index, e);
              }}
              control={
                <CustomCheckbox
                  checked={item.isNumber || false}
                  sx={{ pt: 2 }}
                />
              }
              label="Is Number"
              labelPlacement="top"
            />
          </Grid>
          <Grid item xs={2} sx={{ mt: 2 }}>
            <FormControlLabel
              name="isVerified"
              onChange={(e) => {
                onChangeColumnParams(index, e);
              }}
              control={
                <CustomCheckbox
                  checked={item.isVerified || false}
                  sx={{ pt: 2 }}
                />
              }
              label="Is Verified"
              labelPlacement="top"
            />
          </Grid>
          <Grid item xs={2} sx={{ mt: 2 }}>
            <FormControlLabel
              name="isUpdate"
              onChange={(e) => {
                onChangeColumnParams(index, e);
              }}
              control={
                <CustomCheckbox
                  checked={item.isUpdate || false}
                  sx={{ pt: 2 }}
                />
              }
              label="Is Update"
              labelPlacement="top"
            />
          </Grid>
          <Grid item xs={1.5} sx={{ mt: 2 }}>
            <CustomText sx={{ fontSize: "15px" }}>Default Value</CustomText>
            <CustomTextField
              type="text"
              name={`default${index}Value`}
              id={`default${index}Value`}
              value={item.default || ""}
              onChange={onChangeDefault(index)}
              placeholder="Default"
              sx={{ mb: 2 }}
              fullWidth
            />
          </Grid>
        </Grid>
      </>
    ));
    return displayColumnsRequired;
  }


  useEffect(() => {
    async function fetchValidationTypes() {
      try {
        const response = await Service.getValidationTypes();
        setValidationOptions(response?.data?.data)
        console.log("response", response?.data?.data)
      } catch (error) {
        console.error("Failed to fetch validation types", error);
      }
    }

    fetchValidationTypes();
  }, [])

  return (
    <div className="container">
      <Grid container spacing={0}>
        <Grid item xs={12} md={12}>
          <form>
            <Box>
              {/* <div>{displayForecastGroup}</div> */}
              <CustomTitle sx={{ fontSize: "20px", mb: 2 }}>
                Create Request
              </CustomTitle>
              <CustomText sx={{ fontSize: "20px", mb: 2 }}>
                Please provide details of the new request type below, this
                should include the request name, columns necessary to execute
                the request. Also indicate the different approval stages as well
                as whether the change requested should be auto executed or not
              </CustomText>
              <Box
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  border: 1,
                  borderRadius: 1,
                  p: 3,
                  mb: 2,
                }}
              >
                <br />
                <CustomText>Request Name</CustomText>
                <CustomTextField
                  type="text"
                  name="requestName"
                  id="requestName"
                  value={formik.values.requestName}
                  onChange={formik.handleChange}
                  placeholder="Enter request name"
                  error={
                    formik.touched.requestName &&
                    Boolean(formik.errors.requestName)
                  }
                  helperText={
                    formik.touched.requestName && formik.errors.requestName
                  }
                  sx={{ mb: 2 }}
                  fullWidth
                />
                <br />

                <CustomText>Database Type</CustomText>
                <CustomTextField
                  name="database_type"
                  id="database_type"
                  value={formik.values.database_type}
                  onChange={formik.handleChange}
                  // label="Select Season"
                  select
                  error={
                    formik.touched.database_type &&
                    Boolean(formik.errors.database_type)
                  }
                  helperText={
                    formik.touched.database_type && formik.errors.database_type
                  }
                  fullWidth
                  sx={{ mb: 2 }}
                >
                  <MenuItem value={1}>MySQL-GCP</MenuItem>
                  <MenuItem value={2}>Postgress</MenuItem>
                  <MenuItem value={3}>MySQL-Bluehost</MenuItem>
                </CustomTextField>
                <Validation
                  selectedValidations={selectedValidations}
                  validationOptions={validationOptions}
                  handleValidationChange={handleValidationChange}
                  removeValidation={removeValidation}
                />

                <CustomText>DB Operation Type</CustomText>
                <CustomTextField
                  name="dbOperationType"
                  id="dbOperationType"
                  value={formik.values.dbOperationType}
                  onChange={formik.handleChange}
                  // label="Select Season"
                  error={
                    formik.touched.dbOperationType &&
                    Boolean(formik.errors.dbOperationType)
                  }
                  helperText={
                    formik.touched.dbOperationType &&
                    formik.errors.dbOperationType
                  }
                  select
                  fullWidth
                  sx={{ mb: 2 }}
                >
                  <MenuItem value={"insert"}>Insert</MenuItem>
                  <MenuItem value={"update"}>Update</MenuItem>
                  <MenuItem value={"delete"}>Delete</MenuItem>
                </CustomTextField>

                <br />
                <CustomText>Database name</CustomText>
                <CustomTextField
                  type="text"
                  name="database_name"
                  id="database_name"
                  value={formik.values.database_name}
                  onChange={formik.handleChange}
                  placeholder="Enter database name"
                  error={
                    formik.touched.database_name &&
                    Boolean(formik.errors.database_name)
                  }
                  helperText={
                    formik.touched.database_name && formik.errors.database_name
                  }
                  sx={{ mb: 2 }}
                  fullWidth
                />
                <CustomText>Database table</CustomText>
                <CustomTextField
                  type="text"
                  name="database_table"
                  id="database_table"
                  value={formik.values.database_table}
                  onChange={formik.handleChange}
                  placeholder="Enter database/table"
                  error={
                    formik.touched.database_table &&
                    Boolean(formik.errors.database_table)
                  }
                  helperText={
                    formik.touched.database_table &&
                    formik.errors.database_table
                  }
                  sx={{ mb: 2 }}
                  fullWidth
                />

                <CustomText>No. of Columns Required</CustomText>
                <CustomTextField
                  type="number"
                  onWheel={(event) => event.target.blur()}
                  name="noOfColumnsRequired"
                  id="noOfColumnsRequired"
                  value={formik.values.noOfColumnsRequired}
                  onChange={formik.handleChange}
                  placeholder="Enter number of columns required"
                  error={
                    formik.touched.noOfColumnsRequired &&
                    Boolean(formik.errors.noOfColumnsRequired)
                  }
                  helperText={
                    formik.touched.noOfColumnsRequired &&
                    formik.errors.noOfColumnsRequired
                  }
                  sx={{ mb: 2 }}
                  fullWidth
                />
                <CustomText sx={{ fontSize: "16px", color: "gray", py: 3 }}>
                  *Ensure Column 1 is the Primary Key*
                </CustomText>
                {formik.values.noOfColumnsRequired && getColumnsRequired()}

                <CustomText>Method of Execution</CustomText>
                <CustomTextField
                  name="executionMethod"
                  id="executionMethod"
                  value={formik.values.executionMethod}
                  onChange={formik.handleChange}
                  // label="Select Season"
                  select
                  error={
                    formik.touched.executionMethod &&
                    Boolean(formik.errors.executionMethod)
                  }
                  helperText={
                    formik.touched.executionMethod &&
                    formik.errors.executionMethod
                  }
                  fullWidth
                  sx={{ mb: 2 }}
                >
                  <MenuItem value={"auto"}>Auto</MenuItem>
                  <MenuItem value={"manual"}>Manual</MenuItem>
                  <MenuItem value={"override"}>Override</MenuItem>
                </CustomTextField>

                <CustomText>Is Zonal Approval Required ?</CustomText>
                <CustomTextField
                  name="zonalApproval"
                  id="zonalApproval"
                  value={formik.values.overrideApprovals ? false : formik.values.zonalApproval}
                  onChange={formik.handleChange}
                  disabled
                  select
                  error={
                    formik.touched.zonalApproval &&
                    Boolean(formik.errors.zonalApproval)
                  }
                  helperText={
                    formik.touched.zonalApproval && formik.errors.zonalApproval
                  }
                  fullWidth
                  sx={{ mb: 2 }}
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </CustomTextField>

                <CustomText>Is SHP Head Approval Required ? </CustomText>
                <CustomTextField
                  name="shpHeadApproval"
                  id="shpHeadApproval"
                  value={formik.values.shpHeadApproval}
                  disabled={formik.values.executionMethod === "override"}
                  onChange={formik.handleChange}
                  // label="Select Season"
                  select
                  error={
                    formik.touched.shpHeadApproval &&
                    Boolean(formik.errors.shpHeadApproval)
                  }
                  helperText={
                    formik.touched.shpHeadApproval &&
                    formik.errors.shpHeadApproval
                  }
                  fullWidth
                  sx={{ mb: 2 }}
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </CustomTextField>
                <CustomText>Do you want to Override Approvals ?</CustomText>
                <CustomTextField
                  name="overrideApprovals"
                  id="overrideApprovals"
                  value={formik.values.overrideApprovals}
                  onChange={formik.handleChange}
                  disabled
                  select
                  error={
                    formik.touched.overrideApprovals &&
                    Boolean(formik.errors.overrideApprovals)
                  }
                  helperText={
                    formik.touched.overrideApprovals && formik.errors.overrideApprovals
                  }
                  fullWidth
                  sx={{ mb: 2 }}
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </CustomTextField>

                <CustomText> Request Type Description</CustomText>
                <CustomTextField
                  type="text"
                  multiline
                  name="requestTypeDescription"
                  id="requestTypeDescription"
                  value={formik.values.requestTypeDescription}
                  onChange={formik.handleChange}
                  placeholder="Describe this request type"
                  error={
                    formik.touched.requestTypeDescription &&
                    Boolean(formik.errors.requestTypeDescription)
                  }
                  helperText={
                    formik.touched.requestTypeDescription &&
                    formik.errors.requestTypeDescription
                  }
                  sx={{ mb: 2 }}
                  fullWidth
                />
              </Box>
            </Box>
          </form>
          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <CustomButton
              // onClick={(e) => saveFormData()}
              onClick={formik.handleSubmit}
              variant="contained"
              disabled={loading}
              sx={{
                alignItems: "center",
                py: 2,
                px: 8,
                m: 2,
                background: "#58CC02",
              }}
            >
              {loading ? "Submitting" : "Create"}
            </CustomButton>
          </Box>

          {submitted && (
            <p style={{ color: "green", textAlign: "center" }}>
              Request created successfully
            </p>
          )}
          {errorMsg ? (
            <h3 style={{ color: "red", textAlign: "center" }}>
              Failed to create request
            </h3>
          ) : null}
        </Grid>
      </Grid>
    </div>
  );
};

export default CreateRequest;
